import React from 'react';
import { Row } from './row';

export const SpacerRow = ({ colspan, paddingBottom }) => (
  <Row>
    <td colSpan={colspan} style={{ paddingBottom: paddingBottom }}></td>
  </Row>
);
